import React, { FunctionComponent } from 'react';

import {
  INSURED_SINCE_POSSES_OPTIONS,
  MotorFullPageProps,
} from 'scenes/motor/types';
import { getInsuredSincePossessed } from 'scenes/motor/selectors';
import { SingleSegmentedControlStep } from 'scenes/common/components/Steps';

const STATE_KEY = 'isInsuredSincePossessed';
const QUESTION =
  'Has the car had comprehensive car insurance for the period between when you took possession of the car and now?';

const InsuredSincePossessedStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleSegmentedControlStep
    stack
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    options={INSURED_SINCE_POSSES_OPTIONS}
    defaultStateValue={getInsuredSincePossessed(funnelState)}
    validationRules={{
      validate: {
        oneOf: (value) =>
          INSURED_SINCE_POSSES_OPTIONS.some((option) => option.value === value),
      },
    }}
  />
);

export default InsuredSincePossessedStep;
